import { type IEngineSemanticTag } from './IEngineSemanticTag.ts';

/**
 * Verifica se un tag semantico è univoco, ovvero aggregazione `UNIVOCA`
 * e non multiplo. Solo i tag univoci possono essere sincronizzati live
 * tra widget che li espongono.
 */
export function isUniqueSemanticTag(tag: IEngineSemanticTag): boolean {
  if (tag.aggregazione !== 'UNIVOCA') return false;
  if (tag.flMultiplo) return false;
  return true;
}
